<template>
  <div>
    <spacer :y="5"/>
    <ul>
      <stack-item>
        <contents-box title="予約一覧">
          <loader-simple
            :flag="flag.loader"
            v-if="flag.loader" />
          <div v-if="!flag.loader">
            <p v-if="uncheckedCount">未確認のオンライン・バーチャル健康相談が <span :class="$style.bold">{{ uncheckedCount }}件 </span>あります</p>
            <p v-if="!uncheckedCount">未確認のオンライン・バーチャル健康相談はありません。</p>

            <spacer :y="2" v-if="user.counseling.op.reserve.future.length"/>
            <ul>
              <stack-item
                v-for="row in user.counseling.op.reserve.future"
                :key="row.id"
                :class="$style.new_wrap"
                :id="`online_counseling_reserve_${row.id}`">
                <contents-box
                  type="inner" :title="formatTimestamp(row.schedule.date, `YYYY年MM月DD日（${row.weekday.label}）HH:00`)"
                  icon="<i class='fa-solid fa-user-doctor'/>">
                  <spacer :y="1"/>
                  <user-box
                    type="inner"
                    :user="row.fromUser"
                    :ownUser="user"
                    :showMessageBtn="true"
                    :showCocomoniBtn="true"
                    :showId="true"
                    :bg="userBoxColor(row.fromUser)"
                    :link="`/operator/history/${row.fromUser.id}`"
                    :targetBlank="true">
                    <template v-slot:btn>
                      <div :class="[$style.clickarea, $style.open]" v-on:click="changeOpenIds(row.id), getMostRect(row)">
                        <i
                          v-if="openIds.includes(row.id)"
                          :class="$style.icon"
                          class="fa-regular fa-minus"></i>
                        <i
                          v-if="!openIds.includes(row.id)"
                          :class="$style.icon"
                          class="fa-regular fa-plus"></i>
                      </div>
                    </template>
                    <template v-slot:main>
                      <div>
                        <spacer :y="2"/>
                        <ul :class="$style.detail">
                          <li>
                            <label-box label="担当" color="gray" size="sm" :class="$style.label"/>
                            <p :class="[$style.content, $style.counseling_wrap]">
                              {{ row.toUser.username }}（{{ helper.master.labels.users.account_type[row.toUser.account_type] }}）
                              <i
                                v-if="row._counselingType.counseling_type === 1"
                                class="fa-regular fa-laptop"
                                :class="[
                                  $style.counseling_icon,
                                  $style.online,
                                ]"
                              ><i :class="$style.counseling_icon_inner" class="fa-regular fa-user-headset"/></i>
                              <i
                                v-if="row._counselingType.counseling_type === 3"
                                class="fa-solid fa-vr-cardboard"
                                :class="[
                                  $style.counseling_icon,
                                  $style.virtual,
                                ]"
                              ></i>
                            </p>
                          </li>
                          <li>
                            <label-box label="申込日" color="gray" size="sm" :class="$style.label"/>
                            <p :class="$style.content">{{ formatTimestamp(row.created_at, 'YYYY/MM/DD HH:mm') }}</p>
                          </li>
                        </ul>
                      </div>
                      <div
                        :class="$style.drawer"
                        v-if="openIds.includes(row.id)">
                        <ul :class="$style.detail">
                        <spacer :y="1.5"/>
                          <li>
                            <label-box label="実施日" color="gray" size="sm" :class="$style.label"/>
                            <p :class="$style.content">{{ formatTimestamp(row.schedule.date, 'YYYY/MM/DD HH:00〜HH:45') }}</p>
                          </li>
                          <li v-if="isOnline(row) && row.meeting">
                            <label-box label="URL" color="gray" size="sm" :class="$style.label"/>
                            <p :class="$style.content"><a :href="row.meeting.join_url" target="_blank">{{ row.meeting.join_url }}</a></p>
                          </li>
                          <!-- virtualCastProps 行を欠くと内側の deref で一覧ごと描画が落ちるため、上のオンライン URL 行（row.meeting）と同様に行単位で伏せる -->
                          <li v-if="isVirtual(row) && row.toUser?.virtualCastProp">
                            <label-box label="URL" color="gray" size="sm" :class="$style.label"/>
                            <p :class="$style.content"><a :href="getVirtualCastMedicalRooomURL(row.toUser.virtualCastProp.virtual_cast_room_key)" target="_blank">{{ getVirtualCastMedicalRooomURL(row.toUser.virtualCastProp.virtual_cast_room_key) }}</a></p>
                          </li>
                          <li v-if="isVirtual(row) && row.fromUser?.virtualCastProp">
                            <label-box label="Virtual Cast ID" color="gray" size="sm" :class="$style.label"/>
                            <div>
                              <p :class="$style.content">{{ row.fromUser.virtualCastProp.virtual_cast_id }}</p>
                              <p :class="$style.virtualcast_url"><a :href="getVirtualCastUserURL(row.fromUser.virtualCastProp.virtual_cast_id)" target="_branc">{{ getVirtualCastUserURL(row.fromUser.virtualCastProp.virtual_cast_id) }}</a></p>
                            </div>
                          </li>
                          <li>
                            <label-box label="お悩み" color="gray" size="sm" :class="$style.label"/>
                            <div :class="[$style.value, $style.type, hasSubTypesRecorded(row) ? $style.typeCompany : '']">
                              <p
                                v-for="rType in sortWorryTypes(row.type)"
                                :key="rType">{{ getWorryTypeLabel(rType, isCompany(row), 'reserve') }}<span v-if="row.other_text && rType === 6">（{{ row.other_text }}）</span>
                                <span v-if="getWorrySelectedSubText(rType, getRecordedSubs(row, rType), isCorporate(row), 'reserve')" :class="$style.subList">{{ getWorrySelectedSubText(rType, getRecordedSubs(row, rType), isCorporate(row), 'reserve') }}</span>
                              </p>
                            </div>
                          </li>
                          <li v-if="row.memos.customer.length">
                            <label-box label="相談内容" color="gray" size="sm" :class="$style.label"/>
                            <p :class="$style.content" class="multilineText">{{ row.memos.customer[0].memo }}</p>
                          </li>
                          <!-- who5Answers 行を持たない予約では内側の answers 参照が無ガードで落ち、一覧ごと描画されないためラベルごと伏せる -->
                          <li v-if="row.who5Answer">
                            <label-box label="ココモニ" color="gray" size="sm" :class="$style.label"/>
                            <div :class="$style.content">
                              <p :class="$style.who5_score">
                                <span :class="$style.who5_score_label">ココモニチェック</span>{{ row.scoreWho5 }}点
                                <i class="fa-solid fa-chart-line" :class="$style.chartIcon" @click="showUserChart(row.fromUser)" title="推移グラフ"/>
                              </p>
                              <ul :class="$style.who5">
                                <li v-for="(item, i) in helper.master.who5.items" :key="item">
                                  <p>{{ item.label }}</p>
                                  <p :class="$style.who5_answer">{{ helper.master.who5.labels[row.who5Answer.answers[i]] }}</p>
                                </li>
                              </ul>
                            </div>
                          </li>
                          <li class="n2br">
                            <label-box :label="isCompany(row) ? '企業コメント' : '学校コメント'" color="gray" size="sm" :class="$style.label"/>
                            <div v-if="row.memos.teacher.length">
                              <!-- 投稿者「[管理者/副管理者]・氏名 [最終更新日時]」を表示（11は文言統一で「主」を付けない・職階は出さない） -->
                              <p :class="$style.postUser">{{ getMemoAuthorName(row.memos.teacher[0]) }} [{{ filterMoment(row.memos.teacher[0].updated_at, 'YYYY.MM.DD HH:mm') }}]</p>
                              <p v-html="row.memos.teacher[0].memo"></p>
                            </div>
                            <p v-if="!row.memos.teacher.length">記入なし</p>
                          </li>
                          <li class="n2br">
                            <label-box label="事務局メモ" color="gray" size="sm" :class="$style.label"/>
                            <p
                              :class="$style.content"
                              v-if="row.memos.operator.length && editId !== row.id"
                              v-html="row.memos.operator[0].memo"/>
                            <p :class="$style.content" v-else-if="row.id !== editId">登録なし</p>
                            <div v-else :class="$style.textarea_wrap">
                              <textarea
                                name="memo"
                                id="memo"
                                rows="5"
                                :class="$style.textarea"
                                v-model="memo"/>
                              <spacer :y="1"/>
                              <btn-container>
                                <basic-btn
                                  tag="button"
                                  size="sm"
                                  v-on:click="registMemo(row)">保存</basic-btn>
                                  <spacer :x="2"/>
                                <basic-btn
                                  tag="button"
                                  size="sm"
                                  type="bdr"
                                  v-on:click="editStart(null)">やめる</basic-btn>
                              </btn-container>
                            </div>
                            <i
                              v-if="row.id !== editId"
                              class="fa-regular fa-pen-to-square"
                              :class="$style.editIcon"
                              v-on:click="editStart(row)"/>
                          </li>
                          <li class="n2br" :class="$style.fReserve_center">
                            <label-box label="オンライン<br>バーチャル<br>予約" color="gray" size="sm" :class="[$style.label, $style.fReserve_content]" smAlign="left"></label-box>
                            <ul v-if="futureReserveMap[row.id] && futureReserveMap[row.id].length" :class="$style.nearest_box">
                              <li v-for="fReserve in futureReserveMap[row.id]" :key="fReserve">
                                <table>
                                  <tr>
                                    <td :class="$style.fReserve_label">申込日</td>
                                    <td :class="$style.fReserve_value">{{ formatTimestamp(fReserve.created_at, 'YYYY/MM/DD  HH:mm') }}</td>
                                  </tr>
                                  <tr>
                                    <td :class="$style.fReserve_label">実施情報</td>
                                    <td :class="[$style.fReserve_value, $style.counseling_wrap]">
                                      {{ formatTimestamp(fReserve.schedule.date, `YYYY/MM/DD  HH:00〜HH:45`) }}　{{ fReserve.toUser.username }}
                                      <i
                                        v-if="isOnline(fReserve)"
                                        class="fa-regular fa-laptop"
                                        :class="[
                                          $style.counseling_icon,
                                          $style.online,
                                        ]"
                                      ><i :class="$style.counseling_icon_inner" class="fa-regular fa-user-headset"/></i>
                                      <i
                                        v-if="isVirtual(fReserve)"
                                        class="fa-solid fa-vr-cardboard"
                                        :class="[
                                          $style.counseling_icon,
                                          $style.virtual,
                                        ]"
                                      ></i>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td :class="$style.fReserve_label">お悩み</td>
                                    <td :class="$style.fReserve_value"><span v-for="wType in sortWorryTypes(fReserve.type)" :key="wType" :class="hasSubTypesRecorded(fReserve) ? $style.fReserveTypeCompany : ''">{{ getWorryTypeLabel(wType, isCompany(row), 'reserve') }}
                                      <span v-if="getWorrySelectedSubText(wType, getRecordedSubs(fReserve, wType), isCorporate(row), 'reserve')" :class="$style.subList">{{ getWorrySelectedSubText(wType, getRecordedSubs(fReserve, wType), isCorporate(row), 'reserve') }}</span><template v-if="!hasSubTypesRecorded(fReserve)">　</template></span></td>
                                  </tr>
                                  <tr>
                                    <td :class="$style.fReserve_label">相談内容</td>
                                    <td :class="$style.fReserve_value">{{ getCustomerMemo(fReserve.memos.customer) }}</td>
                                  </tr>
                                </table>
                              </li>
                            </ul>
                            <p v-else :class="$style.fReserve_none">以降の予約無し</p>
                          </li>
                        </ul>
                      </div>
                    </template>
                  </user-box>
                </contents-box>
                <div
                  :class="$style.new"
                  v-if="user.readflags && !user.readflags.reserves.includes(row.id)">NEW</div>
              </stack-item>
            </ul>
          </div>
        </contents-box>
      </stack-item>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import StackItem from '@/views/components/StackItem.vue';
import ContentsBox from '@/views/components/ContentsBox.vue';
import UserBox from '@/views/components/UserBox.vue';
import LabelBox from '@/views/components/LabelBox.vue';
import LoaderSimple from '@/views/components/LoaderSimple.vue';
import BtnContainer from '@/views/components/BtnContainer.vue';
import BasicBtn from '@/views/components/BasicBtn.vue';
import Spacer from '@/views/components/Spacer.vue';
import cf from '@/mixins/commonFunctions.js';
import corporateSchool from '@/mixins/corporateSchool.js';
import moment from 'moment';

export default {
  name: 'operator-online-counseling',
  mixins: [cf, corporateSchool],
  components: {
    StackItem,
    ContentsBox,
    UserBox,
    LabelBox,
    LoaderSimple,
    BtnContainer,
    BasicBtn,
    Spacer,
  },
  data() {
    return {
      flag: {
        loader: true,
      },
      // reserves: [],
      openIds: [],
      editId: null,
      memo: null,
      uncheckedCount: 0,
      reserveCounselingTypes: {}, // key: reserve_id, value: counseling_type
      futureReserveMap: {}, // key: reserve_id, value: future_reserve_array
    };
  },
  created() {
    // Operator/Home.vueでユーザ情報取得の後
    // componentを呼び出しているためthis.userは
    // すぐに取得できる
    this.getReserves();
  },
  computed: {
    ...mapState(['helper', 'user']),
  },
  watch: {
    '$route.query': {
      handler() {
        this.$nextTick(() => {
          // URLのクエリが変更されたときの処理
          if (this.user.counseling.op.reserve.future.length > 0) {
            // 表示情報が取得済みの場合のみスクロールを発動する
            this.scroll2OpenItem();
          }
        });
      },
      immediate: true,
    },
  },
  mounted() {
    // storeを監視して未確認予約件数をカウントし直し
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'user/update') {
        this.countUnchecked();
      }
    });
  },
  methods: {
    showUserChart(user) {
      if (!user || !user.school || !user.school.length) return;
      const args = {
        modalName: 'user-chart-who5',
        data: {
          school: user.school[0],
          user,
          hideChangeUser: true,
        },
      };
      this.$store.dispatch('modal/contents/showModal', args, { root: true });
    },
    isCompany(row) {
      return Boolean(row && row.fromUser && row.fromUser.school.length && row.fromUser.school[0].is_company);
    },
    // 企業固有のお悩みサブ項目ゲート専用（インターン id=18 では false）。ラベル(#3238)は isCompany 据え置き。
    isCorporate(row) {
      return this.isCorporateSchool(row?.fromUser?.school);
    },
    // 該当予約までスクロール
    scroll2OpenItem() {
      // クエリでidが渡ってきたとき（ホームのステータスから飛んだとき）
      // this.openIdsにidを格納しその予約までスクロール
      const query = this.$route.query;
      if (!query || !query.open) return; // クエリが不正な場合は処理を中止

      const id = Number(query.open);
      this.$nextTick(() => {
        // 対象の予約情報要素を取得
        const elem = document.getElementById(`online_counseling_reserve_${id}`);
        if (!elem) return;
        // 予約情報を開く
        this.changeOpenIds(id);
        // 対象者の直近予約情報を取得
        const targetReserve = this.user.counseling.op.reserve.future.find((row) => row.id === id);
        if (targetReserve) {
          this.getMostRect(targetReserve);
        }
        // 対象の予約情報要素までスクロール
        const position = elem.getBoundingClientRect().top;
        scrollBy(0, position - 77);
      });
    },
    getReserves(reload = false) {
      if (!reload && this.user.counseling.op.reserve.future.length) {
        // すでにstoreへデータが登録されている場合は終了
        this.flag.loader = false;
        return;
      }

      const params = {
        flags: [1],
        // isRisk: 1,
        isRisk: 0,
        counseling_type: -1, // オンライン・バーチャル
      };
      this.axios({
        method: 'GET',
        url: '/v1/reserve/get/list',
        // url: '/v2/reserve/get/list',
        params,
      })
        .then((response) => {
          const res = response.data;
          const commitData = {
            type: 'reserve',
            division: 'future',
            values: cf.upSortReserves(res.reserves.data),
          };
          this.$store.commit('user/counseling/putOperatorDatas', commitData);
          this.countUnchecked();
          this.scroll2OpenItem();
          this.setReserveCounselingType();
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },
    countUnchecked() {
      this.uncheckedCount = 0;
      this.user.counseling.op.reserve.future.forEach((row) => {
        if (this.user.readflags && !this.user.readflags.reserves.includes(row.id)) {
          this.uncheckedCount += 1;
        }
      });
      this.flag.loader = false;
    },
    changeOpenIds(n) {
      if (this.user.readflags && !this.user.readflags.reserves.includes(n)) this.registReadFlag(n);
      if (this.openIds.includes(n)) {
        const idx = this.openIds.indexOf(n);
        this.openIds.splice(idx, 1);
      } else {
        this.openIds.push(n);
      }
    },

    // 該当利用者の直近の未実施オンライン/バーチャル健康相談を取得
    async getMostRect(reserve) {
      try {
        const futureReserve = [];
        {
          // まずはオンライン健康相談を取得
          const params = {
            from_user_id: reserve.from_user_id,
            orderBy: 'asc',
            progress: 1,
            withWho5: true,
            withType: true,
            withMeeting: true,
            isUserWatch: 1,
            isRisk: 1,
            counseling_type: 1, // オンライン健康相談
          };
          const response = await this.axios({
            method: 'GET',
            url: '/v2/reserve/get/list',
            params,
          });
          const res = response.data.result.data;
          res.forEach((data) => { // 該当予約以外の予約
            if (data.from_user_id === reserve.from_user_id && data.id !== reserve.id) {
              futureReserve.push(data);
            }
          });
        }

        {
          // 続いてバーチャル健康相談を取得
          const virtualParams = {
            from_user_id: reserve.from_user_id,
            orderBy: 'asc',
            progress: 1,
            withWho5: true,
            withType: true,
            withMeeting: true,
            isUserWatch: 1,
            isRisk: 1,
            counseling_type: 3, // バーチャル健康相談
          };
          const response = await this.axios({
            method: 'GET',
            url: '/v2/reserve/get/list',
            params: virtualParams,
          });
          const res = response.data.result.data;
          res.forEach((data) => { // 該当予約以外の予約
            if (data.from_user_id === reserve.from_user_id && data.id !== reserve.id) {
              futureReserve.push(data);
            }
          });
        }

        // 日付順にソートしてセット
        if (futureReserve.length === 0) {
          return;
        }
        this.futureReserveMap[reserve.id] = futureReserve.sort((a, b) => moment(a.schedule.date).diff(moment(b.schedule.date)));

      } catch (error) {
        if (error.message) console.log(error);
        else console.log(error);
      }
    },

    registReadFlag(reserveId) {
      const data = {
        model_type: 3, // オンライン健康相談予約
        user_id: this.user.id,
        foreign_id: reserveId,
      };
      this.axios({
        method: 'POST',
        url: '/v1/readflag/set/register',
        data,
      })
        .then(() => {
          this.$store.dispatch('user/update');
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },
    editStart(reserve) {
      if (reserve) {
        this.editId = reserve.id;
        if (reserve.memos.operator.length) this.memo = reserve.memos.operator[0].memo;
        else this.memo = null;
      } else {
        this.editId = null;
        this.memo = null;
      }
    },

    /** userBox背景色指定用 */
    userBoxColor(user) {
      let color;
      if ((user.flag !== 1 || user.school) && user.school.length && user.school[0].flag !== 1) {
        color = 'gray';
      } else if (user.flag !== 1) {
        color = 'gray';
      } else if (user.temporary) {
        color = 'silver';
      } else if (user.risk.length && user.risk[user.risk.length - 1].type !== 11) {
        color = 'red';
      } else {
        color = 'white';
      }
      return color;
    },

    registMemo(row) {
      const data = {
        id: row.memos.operator.length ? row.memos.operator[0].id : null,
        memo: this.memo,
        user_id: this.user.id,
        reserve_id: row.id,
      };
      const endpoint = data.id ? 'updater' : 'register';
      this.axios({
        method: 'POST',
        url: `/v1/reserve/memo/set/${endpoint}`,
        data,
      })
        .then(() => {
          this.editId = null;
          this.memo = null;
          this.getReserves(true);
          alert('メモを更新しました。');
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },

    isOnline(reserve) {
      return reserve._counselingType.counseling_type === 1;
    },
    isVirtual(reserve) {
      return reserve._counselingType.counseling_type === 3;
    },
    setReserveCounselingType() {
      this.reserves.forEach((reserve) => {
        this.reserveCounselingTypes[reserve.id] = reserve.type.counseling_type;
      });
    },
    cancelReserve(reserve) {
      const args = {
        modalName: 'reserveCancel',
        data: {
          reserve_id: reserve.id,
          counseling_type: this.reserveCounselingTypes[reserve.id],
          schedule: reserve.schedule,
          customer_id: reserve.fromUser?.customer_id,
        },
      };
      this.$store.dispatch('modal/contents/showModal', args, { root: null });
    },
  },
};
</script>

<style lang="scss" module>
.list {
  display: flex;
  align-items: center;
  cursor: pointer;

  &_wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.label {
  width: 105px;
  min-width: 105px;
  margin-right: 20px;
  // .content {
  //   .who5 {
  //     .who5_answer {
  //       font-weight: bold;
  //     }
  //   }
  // }
}
.text_wrap {
  margin-left: 15px;
}
.postUser {
  // メモ本文の上に投稿者氏名＋最終更新日時を表示
  font-weight: bold;
  font-size: 13px;
}
.id {
  font-size: 12px;
}
.clickarea {
  cursor: pointer;
}
.open {
  text-align: right;
  @include sm-view {
    margin-top: 10px;
  }
}
.icon {
  font-size: 20px;
  color: var(--gray-side);
}
.detail {
  li {
    display: flex;
    align-items: flex-start;

    @include sm-view {
      font-size: 13px;
      display: block;
    }
    .content {
      // font-size: 14px;
      margin-top: 3px;
      flex: 1;
      word-break: break-all;
    }
    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }
}
.who5 {
  margin-top: 16px;
  li {
    justify-content: space-between;
  }
  .who5_answer {
    font-weight: bold;
  }
  &_score {
    &_label {
      margin-right: 12px;
    }
  }
}
.chartIcon {
  margin-left: 8px;
  cursor: pointer;
  color: #58b3b1;
  &:hover {
    opacity: 0.7;
  }
}
.types {
  margin-right: 20px;
}
.textarea {
  background-color: var(--gray-sub);
  padding: 13px;
  border: none;
  border-radius: 4px;
  width: 100%;
  outline: none;
  &_wrap {
    flex: 1;
  }
  @include sm-view {
    margin-top: 5px;
  }
}
.editIcon {
  margin-left: 6px;
  margin-top: 6px;
}
.new {
  position: absolute;
  background-color: var(--pink);
  color: #fff;
  font-weight: bold;
  font-size: 14px;
  padding: 4px 12px;
  border-radius: 4px;
  top: -3px;
  right: -3px;
  &_wrap {
    position: relative;
  }
}
.bold {
  font-weight: bold;
}
.value {
  flex: 1;
  margin-top: 3px;
  &.type {
    display: flex;
    flex-wrap: wrap;
    p {
      white-space: nowrap;
      &:not(:last-child) {
        &::after {
          margin: 0 5px;
          content: '/';
        }
      }
    }
  }
  // sub_type が保存されているレコード（企業ユーザー）はメインを縦並びにしてセパレータを消す
  &.typeCompany {
    display: block;
    p {
      white-space: normal;
      &:not(:last-child)::after {
        content: '';
        margin: 0;
      }
    }
  }
  p {
    // 「その他」自由記述などで長い半角英字連続が来た時の折り返し（#3244）
    > span {
      word-break: break-all;
      overflow-wrap: break-word;
      white-space: normal;
      // 自由記述は本文 bold とは別の通常重みで表示する
      font-weight: normal;
    }
  }
}
.virtualcast_url {
  font-size: 10px;
}
.counseling {
  display: flex;
  align-items: center;
  &_wrap {
    display: flex;
    align-items: center;
  }
  &_icon {
    font-size: 25px !important;
    position: relative;
    &_inner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -60%);
      font-size: 10px !important;
    }
    &.online {
      color: var(--orange-main);
    }
    &.virtual {
      color: var(--green-main);
    }
  }
}

.fReserve {
  &_content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &_label {
    background-color: var(--gray-sub);
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    padding: .3em 1em;
    border-radius: 5px;
    width: 140px;
  }
  &_value {
    padding-left: 1em;
  }
  &_center {
    align-items: stretch !important;
  }
  &_none {
    display: flex;
    align-items: center;
  }
}
// 過去予約の <span> も企業ユーザー時は縦並びにしてサブが見やすいように
.fReserveTypeCompany {
  display: block;
}
// 企業サイト: メイン項目の下に「選択済み」サブ項目を ' / ' 連結で表示する。
// 表示形は予約入力の確認ステップ（ReserveFormWizard の確認欄）に合わせてある。
// span を block 化して親 <p> 内で改行させる。テンプレ側は1行で書くこと
// （親に white-space: pre-wrap が効く画面があり、改行・インデントが空白として可視化されるため）。
.subList {
  display: block;
  margin: 2px 0 8px 20px;
  font-size: 13px;
  color: #555;
}
</style>
